var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0V0C46.5685 0 60 13.4315 60 30V30C60 46.5685 46.5685 60 30 60V60C13.4315 60 0 46.5685 0 30V30Z",
    fill: "#C2F5C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 40H22.4034V19.6364H28.9659C30.9413 19.6364 32.6316 20.044 34.0369 20.8594C35.4422 21.6681 36.5194 22.8314 37.2684 24.3494C38.0175 25.8608 38.392 27.6705 38.392 29.7784C38.392 31.8996 38.0142 33.7259 37.2585 35.2571C36.5028 36.7817 35.4024 37.955 33.9574 38.777C32.5123 39.5923 30.7557 40 28.6875 40ZM24.8693 37.8125H28.5284C30.2121 37.8125 31.6075 37.4877 32.7145 36.8381C33.8215 36.1885 34.6468 35.2637 35.1903 34.0639C35.7339 32.8641 36.0057 31.4356 36.0057 29.7784C36.0057 28.1345 35.7372 26.7192 35.2003 25.5327C34.6633 24.3395 33.8612 23.4247 32.794 22.7884C31.7268 22.1454 30.3977 21.8239 28.8068 21.8239H24.8693V37.8125Z",
    fill: "#096115"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.6ac4de44c170daff57bad322976b0bd5.svg";
export { ForwardRef as ReactComponent };